import React from "react";
import { Btn } from "../../../AbstractElements";
import ReusableDropdown from "../../../Component/BasicComponents/Dropdowns/RouteDropdown";

import "react-datepicker/dist/react-datepicker.css";
import CustomInput from "../../../Component/BasicComponents/CustomInput";

interface OnboardingConfigurationModalContentProps {
  handleSubmit: (e: React.FormEvent) => void;
  handleClose: () => void;
  chechStatusSubmitAndUpdate: string;
  onboardingStatus?: any;
  setFormData?: any;
  formData?: any;
  buttonDisable?: boolean;
}

const OnboardingConfigurationModalContent: React.FC<
  OnboardingConfigurationModalContentProps
> = ({
  handleSubmit,
  handleClose,
  chechStatusSubmitAndUpdate,
  onboardingStatus,
  formData,
  setFormData,
  buttonDisable,
}) => {
  const today = new Date();
  const yyyy = today.getFullYear();
  const mm = String(today.getMonth() + 1).padStart(2, "0");
  const dd = String(today.getDate()).padStart(2, "0");
  const minDate = `${yyyy}-${mm}-${dd}`;

  return (
    <form onSubmit={handleSubmit}>
      {/* First Input */}
      <ReusableDropdown
        options={onboardingStatus || []}
        value={formData.onboarding_status}
        onChange={(selected: any) => {
          setFormData({ ...formData, onboarding_status: selected });
        }}
        DropdownHeading="Onboarding status"
        asterisk={true}
      />
      <div className="row mb-0 col-sm-12">
        <div className="col-sm-6">
          <CustomInput
            label="Start Date"
            asterisk={true}
            placeholder="Enter Start Date"
            type="date"
            // name="applyDate"
            value={formData.start_date}
            onChange={(e) => {
              setFormData({ ...formData, start_date: e.target.value });
            }}
          />
        </div>

        <div className="col-sm-6 mt-0">
          <CustomInput
            label="End Date"
            asterisk={true}
            placeholder="Enter End Date"
            type="date"
            // name="applyDate"
            value={formData.end_date}
            onChange={(e) => {
              setFormData({ ...formData, end_date: e.target.value });
            }}
          />
        </div>
      </div>

      {/* Buttons */}
      <div className="d-flex justify-content-start mt-3 gap-2">
        <Btn
          style={{ backgroundColor: "#43B9B2", color: "white" }}
          type="submit"
          disabled={buttonDisable}
        >
          {chechStatusSubmitAndUpdate === "Submit"
            ? buttonDisable === false
              ? "Submit"
              : "Submitting..."
            : buttonDisable === false
            ? "Update"
            : "Updating..."}
        </Btn>
        <Btn
          style={{
            backgroundColor: "#F9FAFC",
            color: "#000",
            border: "1px solid #E0E0E0",
          }}
          type="button"
          onClick={handleClose}
        >
          Cancel
        </Btn>
      </div>
    </form>
  );
};

export default OnboardingConfigurationModalContent;
